export default __webpack_public_path__ + "static/media/lightlogo.c68302e9.png";